import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Miscellaneous component
 */
@Component({
  selector: 'app-miscellaneous',
  templateUrl: './miscellaneous.component.html',
  styleUrls: ['./miscellaneous.component.scss'],
})
export class MiscellaneousComponent implements OnInit {
  isEmbed = false;
  constructor(private router: Router) {}

  ngOnInit() {
    this.isEmbed = window.location.pathname !== '/' && window.location.pathname.split('/')[1] === 'embed';
  }

  goHome() {
    this.router.navigate(['/']);
  }
}
